import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IGetDiscountCodesResponse } from '../types/DiscountCode.types';
import { DISCOUNT_CODES_PATH } from './campaignApiBase';

/**
 * Every code this office has ever held plus every codeless discount that targets
 * it, with their usage counts. The BE orders the rows: the ones it will pay
 * first, in the order it pays them, then live rows it would skip, then ended or
 * not-yet-started ones, each of those two tiers newest first. Keep that order —
 * never re-sort on the client.
 * An office with no codes gets `{ appliedCodes: [] }` — an empty list is a
 * success, never a 404, so callers must not treat "empty" as an error.
 */
export const getDiscountCodes = async (): Promise<IGetDiscountCodesResponse> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<IGetDiscountCodesResponse>(DISCOUNT_CODES_PATH, {
    headers,
  });

  return response.data;
};
